import { gql } from '../../../../../hooks'

export const READ_COLLECTIONS = gql`
  query AdministrationReadComponentCollections($id: ID!) {
    aRead(path: "component/collections", id: $id) {
    }
  }
`

export const UPDATE_COLLECTIONS = gql`
  mutation AdministrationUpdateComponentCollections($id: ID!, $data: JSONObject) {
    aUpdate(path: "component/collections", id: $id, data: $data) {
    }
  }
`

export const CREATE_COLLECTIONS = gql`
  mutation AdministrationCreateComponentCollections($data: JSONObject) {
    aCreate(path: "component/collections", data: $data) {
    }
  }
`

export const LIST_COLLECTIONS = gql`
  query AdministrationListComponentCollections(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/collections"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
